import React from 'react';
import type { Testimonial } from './salesData';
interface TestimonialCardProps {
  t: Testimonial;
}
export function TestimonialCard({
  t
}: TestimonialCardProps) {
  return <figure className="flex h-full flex-col rounded-xl border border-stone bg-ivory p-4" data-id="element-171" data-mp="2kgzwc8v38x1p">
      <blockquote className="font-sans text-[0.82rem] leading-relaxed text-charcoal/75" data-id="element-172" data-mp="2kf56qh8vggra">
        "{t.quote}"
      </blockquote>
      <div className="mt-3 flex items-center gap-2.5 border-t border-stone pt-3" data-id="element-173" data-mp="2u7az3s31d070">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sand font-sans text-[0.68rem] font-bold text-gold-deep ring-1 ring-stone-deep" data-id="element-174" data-mp="2z5m860lib6o6">
          {t.initials}
        </span>
        <div data-id="element-175" data-mp="3872jqbo25etz">
          <figcaption className="font-sans text-[0.8rem] font-semibold leading-tight text-charcoal" data-id="element-176" data-mp="386u6ujrxq9is">
            {t.name}
          </figcaption>
          <p className="font-sans text-[0.7rem] text-charcoal/55" data-id="element-177" data-mp="19t0x3fjir4a6">
            {t.role} · {t.location}
          </p>
        </div>
      </div>
    </figure>;
}